import styled from 'styled-components';

export const Container = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));
  margin-bottom: 1.6rem;
  gap: 0.8rem;

  li {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    width: max-content;
    color: var(--white);
    font-weight: 700;
    text-align: center;
  }

  .progressive-items-top {
    display: flex;
    flex-direction: column;
    background: var(--blue_light);
    border: 1px solid var(--blue_light);
    border-radius: 0.2rem;
    padding: 0.6rem 1.8rem;
    min-width: 10rem;
  }

  .progressive-items-top span {
    text-transform: uppercase;
  }

  .progressive-items-top strong {
    font-size: 0.9rem;
  }

  .progressive-items-bottom {
    margin-top: 0.05rem;
    background: var(--gradient_green);
    border: 1px solid var(--white);
    border-radius: 0.2rem;
    width: 100%;
    line-height: 2rem;
    font-size: 0.9rem;
  }

  .progressive-items-top:hover,
  .progressive-items-bottom:hover {
    font-weight: 900;
    color: var(--primary_color);
    background-color: var(--white);
    background: var(--white);
    border: 1px solid var(--primary_color);
  }
`;
